export const dateFormat = {
  default: 'L',
  extended: 'LL',
  file: 'YYYY-MM-DD',
  withHourInUTC: 'DD/MM/YYYY - HH:mm [UTC]Z'
}
